import { useMemo } from 'react';
import { useLocation } from 'react-router';

export function useGetReferalId() {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const referralQueryParam = params.get('referral') ?? '';
  try {
    const referral = JSON.parse(atob(referralQueryParam));
    return referral.Id;
  } catch (error) {
    return null;
  }
}
